import { Component, NgZone, OnInit } from '@angular/core';
import { ApiManagerService } from '@ildes/services/api-manager.service';
import { SessionService } from '@ildes/services/session.service';
import { SessionStore } from '@ildes/stores/session.store';
import { ToastService } from '@ildes/services/toast.service';
import { ActivatedRoute, Router } from '@angular/router';
import { NativeLayerService } from '@ildes/services/native-layer.service'
import { UntypedFormControl, NgForm, FormGroupDirective, UntypedFormGroup, Validators } from '@angular/forms';
import { environment } from 'src/environments/environment';
import { MAIN_ROUTES } from 'src/config';
import { SplashScreen } from '@capacitor/splash-screen';
import { App } from '@capacitor/app';
import { AutoUnsubscribeComponent } from '@ildes/abstracts/auto-unsubscribe.component';
import { MatDialog } from '@angular/material/dialog';
import { PopupsNotificationsDialogComponent } from '../popups-notifications-dialog/popups-notifications-dialog.component'
import { StorageService } from '@ildes/services/storage-service.service';
import { FingerprintService } from '@ildes/services/fingerprint.service';
import { CookiesConsentService } from '@ildes/services/cookies-consent.service';
const url = 'https://ildes.co/assets/app-release.apk';

@Component({
  selector: 'signin',
  templateUrl: './signin.component.html',
  styleUrls: ['./signin.component.css']
})
export class SigninComponent extends AutoUnsubscribeComponent implements OnInit {
  admin = false;
  credentials;
  loading;
  user;
  remember;
  releaseDate = environment.releaseDate;
  isUpdateAvailable;
  progress = 0;
  constructor(
    public native: NativeLayerService,
    private apiManager: ApiManagerService,
    private sessionService: SessionService,
    private toastService: ToastService,
    private router: Router,
    private route: ActivatedRoute,
    private dialog: MatDialog,
    private cookiesService: CookiesConsentService,
    private fingerprint: FingerprintService,
  ) { 
    super();
  }

  ngOnInit(): void {
    localStorage.setItem('requestMaintenances', 'true')
    this.credentials = new UntypedFormGroup({
      'email': new UntypedFormControl('', [ Validators.required, Validators.email ]),
      'password': new UntypedFormControl('', [ Validators.required ])
    });

    this.admin = this.route.snapshot.data['admin']
    if (this.admin) {
        return;
    }

    const sub = SessionStore.getInstance().get$().subscribe((data) => {
        if (data?.user) {
            this.user = data.user;

            return;
        }
    });
    this.addSubscription(sub);
  }

  async calculateUpdateAvailable() {
    this.apiManager.getVersion().subscribe(async (data: any) => {
      const appData = await App.getInfo();
      this.isUpdateAvailable = data.versionCode > parseInt(appData.build);
    }, () => {

    })

  }

  onSubmitCredentials() {
    const { email, password } = this.credentials.controls;

    this.loading = true;
    this.sessionService.create(
        email.value.toLowerCase(),
        password.value,
        this.remember || this.native.isNative,
        this.admin
    ).subscribe(async (data) => {
      if (this.admin) {
        this.router.navigate(['back-office']);
        return;
      }
      this.router.navigate([MAIN_ROUTES[data.user.role.id] || MAIN_ROUTES.NOTHING_ELSE]);
      this.loading = false;
    }, () => {
      this.loading = false;
    });
  }

  setRememberFlag(remember) {
    this.remember = remember;
  }

  go() {
    this.loading = true;
    this.apiManager.getUserDetail(this.user.id).subscribe(async (data: any) => {
      this.loading = false;
      SessionStore.updateUserInfo(data, true);

      this.router.navigate([MAIN_ROUTES[data.role.id] || MAIN_ROUTES.NOTHING_ELSE]);
    }, async () => {
      this.loading = false;
      this.toastService.show(`Datos actualizados por última vez ${new Date(this.user.lastUpdate).toLocaleString()}`, 'warning');
      this.router.navigate([MAIN_ROUTES[this.user.role.id] || MAIN_ROUTES.NOTHING_ELSE]);
    });
  }

  ngAfterViewInit() {
    setTimeout(() => {
      SplashScreen?.hide();
      if (this.native.isNative) {
        this.calculateUpdateAvailable();
      }
    }, 1000);
  }
 
  openDownloadDialog() {
    const dialog = this.dialog.open(PopupsNotificationsDialogComponent, {

    });
  }

  async removeUser() {
    this.cookiesService.removeCookiesData();
    if (this.native.isNative) {
        await this.fingerprint.disable()
      }
      this.sessionService.invalidate();
      window.location.reload();
  }

}
